import type {
  BusinessCaseVersionDto,
  CreateProjectConceptDto,
  ProjectConceptDto,
  ProjectDto,
  UpdateProjectConceptDto,
  UpsertBusinessCaseDraftDto,
} from '@paladin-monorepo/common';
import API from '../api';

export const projectConceptsApi = {
  async list(): Promise<ProjectConceptDto[]> {
    return API.get<ProjectConceptDto[]>('/project-concepts').then((res) => res.data);
  },
  async getById(id: string): Promise<ProjectConceptDto> {
    return API.get<ProjectConceptDto>(`/project-concepts/${encodeURIComponent(id)}`).then((res) => res.data);
  },
  async create(data: CreateProjectConceptDto): Promise<ProjectConceptDto> {
    return API.post<ProjectConceptDto>('/project-concepts', data).then((res) => res.data);
  },
  async update(id: string, data: UpdateProjectConceptDto): Promise<ProjectConceptDto> {
    return API.patch<ProjectConceptDto>(`/project-concepts/${encodeURIComponent(id)}`, data).then((res) => res.data);
  },
  async remove(id: string): Promise<void> {
    return API.delete(`/project-concepts/${encodeURIComponent(id)}`).then(() => undefined);
  },
  async convertToProject(id: string): Promise<ProjectDto> {
    return API.post<ProjectDto>(`/project-concepts/${encodeURIComponent(id)}/convert-to-project`).then((res) => res.data);
  },
  async listBusinessCase(id: string): Promise<BusinessCaseVersionDto[]> {
    return API.get<BusinessCaseVersionDto[]>(`/project-concepts/${encodeURIComponent(id)}/business-case`).then(
      (res) => res.data,
    );
  },
  async upsertBusinessCase(id: string, data: UpsertBusinessCaseDraftDto): Promise<BusinessCaseVersionDto> {
    return API.put<BusinessCaseVersionDto>(
      `/project-concepts/${encodeURIComponent(id)}/business-case`,
      data,
    ).then((res) => res.data);
  },
};
